class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);

       // this.handleIntersects();
        this.bindEvents();
    }

    bindEvents() {
        this.delegateBody.on("filters:sort:changed", () => { this.sendSortByData(); this.sendFiltersData(); });
        this.delegateBody.on("filters:cleared", this.clearFiltersData.bind(this));
        this.delegateBody.on("facet:criteria-changed", this.sendSortByData.bind(this));
    }

    sendSortByData(){
        const isDesktop =  new Responsive().matchesBreakpoint('lap-and-up');
        const oldSortByValue = sessionStorage.getItem("SortByValue");
        const sortBy = isDesktop ? 
            document.querySelector('input[name="sort_by"]:checked') : 
            document.querySelector('#sortby.Drawer--wrapper input[name="sort_by"]:checked');    

        if (!sortBy) return;
        const sortByValue = isDesktop ? 
            sortBy.getAttribute('title').replace(' ', '-') : 
            sortBy.value;

        if (!sortByValue || sortByValue === "" || oldSortByValue === sortByValue) return;
        sessionStorage.setItem("SortByValue", sortByValue)

        dataLayer.push({
            event: "sort_applied",
            sort_by: sortByValue,
        });
    }

    sendFiltersData() {  
        function arraysEqual(arr1, arr2) {
            if (!arr1 || !arr2) return arr1 === arr2;

            return (
                Array.isArray(arr1) &&
                Array.isArray(arr2) &&
                arr1.length === arr2.length &&
                arr1.every((val, index) => val === arr2[index])
            );
        }

        const filtersList = [];
        let oldFiltersList = sessionStorage.getItem("CollectionsFiltersList");
        const filterCheckboxes = document.querySelectorAll('.inputFilterCheckbox');

        if (oldFiltersList) oldFiltersList = JSON.parse(oldFiltersList);

        filterCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                filtersList.push(checkbox.dataset.filterName + ":" + checkbox.value);
            }
        });
        
        if (!filtersList.length || arraysEqual(filtersList, oldFiltersList)) return;

        sessionStorage.setItem("CollectionsFiltersList", JSON.stringify(filtersList));

        dataLayer.push({
            event: "filter_applied",
            filter_by: filtersList,
        });
    }

    clearFiltersData() {
        dataLayer.push({
            event: "clear_filters",
            filter_by: [],
        });

        this.sendSortByData();
    }
    
    handleIntersects(){
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection]');
      
    
        allIntersections.forEach((item) =>{
          const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            root: null, // Use the viewport as the root
            rootMargin: '0px',
            threshold: 0.1 // Trigger the callback when 50% of the target is visible
          });
    
          observer.observe(item);
        })
      }
    
      handleIntersection(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
          const data = JSON.parse(entry.target.querySelector('script[type="application/ld+json"]').textContent)
    
          if (!dataLayer || !data) return;
          dataLayer.push({ ecommerce: null });  
          dataLayer.push(data);
    
          } 
        });
      }
}

new gTagEvents();